import React, { useCallback, useContext } from 'react';
import { Checkbox, CheckboxProps } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import XRayGeneratorManagerContext from 'app/providers/XRayGeneratorManagerProvider/context';
import TechnicianPasswordValidationContext from 'app/providers/TechnicianPasswordValidationProvider/context';
import { selectNoXRayDeletion, toggleNoXRayDeletion } from 'app/redux/viewerConfiguration/reducer';
import { Toggle, ToggleProps } from 'rsuite';

function NoXRayDeletionConfiguration() {
  const dispatch = useDispatch();
  const intl = useIntl();
  const requestValidation = useContext(TechnicianPasswordValidationContext);
  const isNoXRayDeletion: boolean = useSelector(selectNoXRayDeletion) ?? false;

  const onChangeNoXRayDeletion: ToggleProps['onChange'] = useCallback(
    (checked, event) =>
      requestValidation()
        .then(() => dispatch(toggleNoXRayDeletion(checked)))
        .catch(() => {}),
    [dispatch, requestValidation]
  );

  return (
    <div>
      <Toggle
        checked={isNoXRayDeletion}
        size="lg"
        checkedChildren={intl.formatMessage({ id: 'general.ON' })}
        unCheckedChildren={intl.formatMessage({ id: 'general.OFF' })}
        onChange={onChangeNoXRayDeletion}
      />
    </div>
  );
}

export default React.memo(NoXRayDeletionConfiguration);
